import styled from "styled-components";

export const ReportCatalogSidebarContainer = styled.div`
    width: 100%;
    max-width: 340px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--theme-color-secondary);
    overflow: hidden;

    @media only screen and (max-width: 900px) {
        max-width: none;
    }
`;

export const ReportCatalogSidebarHead = styled.div`
    h2 {
        padding: 20px 10px;
    }
`;

export const ReportCatalogSidebarSearch = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 10px;
    border-top: 1px solid var(--border-color-secondary);

    input[type="text"] {
        flex: 1;
    }
`;

export const ReportCatalogSidebarbody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--border-color-secondary);
    overflow-y: auto;
    overflow-x: hidden;
`;

export const ReportCatalogSidebarItems = styled.div`
    background-color: var(--theme-color-secondary);
    color: var(--text-color-secondary);
    /* width: 100%; */
    display: flex;
    justify-content: space-between;
    gap: 5px;
    border-bottom: 1px solid var(--table-border-color);
    padding: 20px;
    cursor: pointer;

    &:last-child {
        border-bottom: none;
    }

    svg {
        width: 18px;
        height: auto;
        color: var(--theme-color-primary);
    }

    &.active {
        background-color: var(--theme-color-primary-light);
        color: var(--text-color-primary);
    }
`;

export const NotificationDot = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--color-error);
`;